
<template>
	<v-card class="card-curvey pa-0 elevation-0">
		<v-card-text class="pa-0">
			<v-layout align-center justify-center>
        <div v-if="campaign && campaign.status && campaign.status !== 'DRAFT' && campaign.status !== 'CANCELED' && campaign.status !== 'SENT'">
          
                <v-btn
                  class="ml-1 mr-0"
                  style="border-top-right-radius: 0; border-bottom-right-radius: 0"
                  :disabled="campaign && (campaign.status === 'SENDING')"
                  :loading="loaders.resume"
                  @click="resume">
                  <v-icon>play_arrow</v-icon>
                  Resume
                </v-btn>
              
            
                <v-btn
                  class="mx-0"
                  style="border-radius: 0;"
                  :disabled="campaign && campaign.status !== 'SENDING'"
                  :loading="loaders.pause"
                  @click="pause">
                  <v-icon>pause</v-icon>
                  Pause
                </v-btn>
              
                <v-btn
                  class="mx-0 mr-1"
                  style="border-top-left-radius: 0; border-bottom-left-radius: 0"
                  :disabled="campaign && campaign.status === 'CANCELED'"
                  :loading="loaders.cancel"
                  @click="cancel">
                  <v-icon>close</v-icon>
                  Cancel
                </v-btn>
              
        </div>
        <span v-if="isScheduled" class="warning--text px-1 font-weight-bold">Scheduled for</span>
			<v-spacer v-if="isScheduled"/>
		<v-flex v-if="campaign && (campaign.status === 'DRAFT' || campaign.status === 'SCHEDULED')" class="pa-0">
		<v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="date"
        lazy
        transition="scale-transition"
        min-width="290px"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="date"
            :disabled="isScheduled"
            readonly
            outline
            style="width: 100px"
            placeholder="Date"
            class="px-1"
            hide-details
            v-on="on"
          />
        </template>
        <v-date-picker v-model="date" :disabled="isScheduled" no-title scrollable :min="$moment().format('YYYY-MM-DD')">
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
          <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
        </v-date-picker>
      </v-menu>
      </v-flex>
      <v-flex v-if="campaign && (campaign.status === 'DRAFT' || campaign.status === 'SCHEDULED')" class="pa-0">
      <v-menu
        ref="menuTime"
        v-model="menu2"
        :disabled="!!(campaign && campaign.schedule)"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="time"
        lazy
        transition="scale-transition"
        min-width="290px"
        offset-y

      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="time"
            :disabled="isScheduled"
            :class="[{ 'mr-1': campaign && schedule }]"
            placeholder="Time"
            readonly
            outline
            style="width: 60px"
            hide-details
            v-on="on"
          />
        </template>
        <v-time-picker
          v-if="menu2"
          v-model="time"
          full-width
          @click:minute="$refs.menuTime.save(time)"
        />
      </v-menu>
  </v-flex>
  <v-flex v-if="campaign && (campaign.status === 'DRAFT' || campaign.status === 'SCHEDULED')" class="pa-0">
  	<v-btn
      v-if="!isScheduled"
      color="black"
      dark
      :loading="loaders.schedule"
      @click="scheduleCampaign">Schedule</v-btn>
  </v-flex>
</v-layout>
		</v-card-text>
	</v-card>
</template>

<script>
export default {

  name: 'ScheduleCampaign',
  props: {
    campaign: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      time: null,
      menu2: false,
      loaders: {
        resume: false,
        pause: false,
        stop: false,
        cancel: false,
        schedule: false
      }
    }
  },
  computed: {
    campaignId() {
      return this.$route.params.id
    },
    schedule() {
      if(!this.campaign) {
        return null;
      }
      return this.campaign.schedule
    },
    isScheduled() {
      return !!(this.schedule && this.campaign && this.campaign.status === 'SCHEDULED')
    }
  },
  watch: {
    schedule: {
      immediate: true,
      handler(val) {
        if(val) {
          this.date = this.$moment(val.date).format('YYYY-MM-DD')
          this.time = this.$moment(val.date).format('HH:mm')
        }
      } 
    }
  },
  methods: {
    scheduleCampaign() {
      if(!this.date || !this.time) {
        this.$store.dispatch('setErrorMessage', 'Select Date and Time first.')
        return
      }
      this.loaders.schedule = true
      let date = this.$moment(`${this.date} ${this.time}`).toISOString()
      this.$http_chat.put(`/campaigns/${this.campaignId}/schedule`, { date, "frequency": "daily" })
      .then(()=>{
        this.$emit('success')
        this.loaders.schedule = false
      }).catch((err)=>{
        if(err.response && err.response.data && err.response.data.message) {
          this.$store.dispatch('setErrorMessage', err.response.data.message.error)
        } else {
          this.$store.dispatch('setErrorMessage', true)
        }
        this.loaders.schedule = false
        this.$store.dispatch('setLoader', false)
      })
    },
    async resume() {
      try {
        this.loaders.resume = true
        await this.$http_chat.put(`/campaigns/${this.$route.params.id}/resume`)
        this.loaders.resume = false
        this.$emit('updated')
        return true
      } catch (err) {
        if(err.response && err.response.data && err.response.data.message) {
          this.$store.dispatch('setErrorMessage', err.response.data.message)
        } else {
          this.$store.dispatch('setErrorMessage', true)
        }
        this.loaders.resume = false
      }
    },
    async pause() {
      try {
        this.loaders.pause = true
        await this.$http_chat.put(`/campaigns/${this.$route.params.id}/pause`)
        this.loaders.pause = false
        this.$emit('updated')
        return true
      } catch (err) {
        this.loaders.pause = false
        if(err.response && err.response.data && err.response.data.message) {
          this.$store.dispatch('setErrorMessage', err.response.data.message)
        } else {
          this.$store.dispatch('setErrorMessage', true)
        }
      }
    },
    async cancel() {
      try {
        this.loaders.cancel = true
        await this.$http_chat.put(`/campaigns/${this.$route.params.id}/cancel`)
        this.loaders.cancel = false
        this.$emit('updated')
        return true
      } catch (err) {
        this.loaders.cancel = false
        if(err.response && err.response.data && err.response.data.message) {
          this.$store.dispatch('setErrorMessage', err.response.data.message)
        } else {
          this.$store.dispatch('setErrorMessage', true)
        }
      }
    },
  }
}
</script>

<style lang="css" scoped>
</style>